import React from 'react';
import ShellPageLayout from '../../components/ShellPageLayout';

/**
 * Settings page layout wrapper — delegates to the shared ShellPageLayout.
 *
 * Uses compact padding (`p-3 sm:p-6`) for tighter mobile spacing.
 */
export default function SettingsLayout({ children, title, description }) {
    return (
        <ShellPageLayout title={title} description={description} compact>
            {children}
        </ShellPageLayout>
    );
}
